import React, { SyntheticEvent, useRef, useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import "./patientdetail.css";
import { calculateAge, capitalizeWords } from "../../Utils/utils"
import Barcode from 'react-barcode'
import { useTheme } from "../../../ui/src/contextProviders"

const PatientDetailHeader = () => {
  const patientdata = useSelector((state: RootState) => state.patientdetailResponce.result);

  const dob = patientdata?.patientDetails?.dob;
  const age = useMemo(() => calculateAge(dob), [dob]);
  const isDarkMode = useTheme();

  return (

    <section className={`form__section patient-header flex ${isDarkMode?.isDarkMode ? "text-[#ffffff]" : "text-[#00000]"}`}>
      <div>
        <ul className='flex'>
          <li>
            <strong>Name : </strong>
            {patientdata?.patientDetails
              ? `${capitalizeWords(patientdata.patientDetails.firstName)} ${capitalizeWords(patientdata.patientDetails.middleName)} ${capitalizeWords(patientdata.patientDetails.lastName)}`.trim() : '--'}
          </li>
          <li>
            <strong>Age : </strong>
            {age ? age : '--'}
          </li>
          <li>
            <strong>UHID : </strong>
            {patientdata?.patientDetails?.UHID ? patientdata?.patientDetails?.UHID : '--'}
          </li>
          <li>
            <strong>Phone Number : </strong>
            {patientdata?.patientDetails?.contactInfo?.mobileNo ? `${patientdata?.patientDetails?.contactInfo?.dialCode} ${patientdata?.patientDetails?.contactInfo?.mobileNo}` : '--'}
          </li>
          <li>
            <strong>Whatsapp Number : </strong>
            {patientdata?.patientDetails?.contactInfo?.whatsappNo ? `${patientdata?.patientDetails?.contactInfo?.whatsappNoDialCode} ${patientdata?.patientDetails?.contactInfo?.whatsappNo}` : '--'}
          </li>
          <li>
            <strong>Blood Group : </strong>
            {patientdata?.patientDetails?.bloodGroup ? patientdata?.patientDetails?.bloodGroup : '--'}
          </li>
          <li>
            <strong>Height : </strong>
            {patientdata?.patientDetails?.height ? `${patientdata.patientDetails.height} cm` : '--'}
          </li>
          <li>
            <strong>Weight : </strong>
            {patientdata?.patientDetails?.weight ? `${patientdata?.patientDetails?.weight} kg` : '--'}
          </li>
        </ul>
      </div>
      <div className='barcode'>
        {patientdata?.patientDetails?.UHID && <Barcode displayValue={false} width={1.2} height={50} value={patientdata?.patientDetails?.UHID} />}
      </div>
    </section>
  )
}
export default PatientDetailHeader
